import { isStaffDomainEmail } from "@workspace/staff";

const STAFF_PREVIEW_KEY = "motus_staff_preview";

type ClerkUserLike = {
  publicMetadata?: Record<string, unknown>;
  primaryEmailAddress?: { emailAddress?: string | null } | null;
} | null | undefined;

export function isStaffUser(user: ClerkUserLike): boolean {
  if (!user) return false;
  const meta = user.publicMetadata;
  if (meta?.isStaff === true || meta?.role === "staff") return true;
  return isStaffDomainEmail(user.primaryEmailAddress?.emailAddress);
}

/**
 * Explicit, opt-in development override. OFF by default; only enabled when
 * `VITE_STAFF_DEV_OVERRIDE === "true"` at build time. Mirrors the backend
 * `STAFF_DEV_OVERRIDE` switch so a developer can reach the admin UI locally
 * without being genuine staff. It must never be on by default.
 */
export function isStaffDevOverrideEnabled(): boolean {
  return import.meta.env.VITE_STAFF_DEV_OVERRIDE === "true";
}

export function setStaffPreviewMode(): void {
  try {
    sessionStorage.setItem(STAFF_PREVIEW_KEY, "1");
  } catch {
    // ignore storage errors
  }
}

export function clearStaffPreviewMode(): void {
  try {
    sessionStorage.removeItem(STAFF_PREVIEW_KEY);
  } catch {
    // ignore storage errors
  }
}

export function isStaffPreviewMode(): boolean {
  try {
    return sessionStorage.getItem(STAFF_PREVIEW_KEY) === "1";
  } catch {
    return false;
  }
}
